import React, { useState } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src="/images/garcias-milho-logo.png" alt="Garcias Milho" style={{ marginTop: '-60px', height: 'auto', marginBottom: '60px' }} />
          </div>
          
          <nav className="nav-menu">
            <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <a href="#home" onClick={() => scrollToSection('home')}>HOME</a>
              <a href="#quem-somos" onClick={() => scrollToSection('quem-somos')}>QUEM SOMOS</a>
              <a href="#produtos" onClick={() => scrollToSection('produtos')}>PRODUTOS</a>
              <a href="#contato" onClick={() => scrollToSection('contato')}>CONTATO</a>
            </div>
            
            <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
